import { WorkloadsAccessContextResponse } from '@cast/types';

export type IsNamespaceWritable = (namespace: string | undefined) => boolean;

export const makeIsNamespaceWritable = (
  accessContext: WorkloadsAccessContextResponse | undefined
): IsNamespaceWritable => {
  return (namespace) => {
    if (!namespace) {
      return false;
    }

    if (!accessContext) {
      return false;
    }

    if (accessContext.isOwner) {
      return true;
    }

    return accessContext.writableNamespaces?.includes(namespace) ?? false;
  };
};

export const isAccessContextOwner = (
  accessContext: WorkloadsAccessContextResponse | undefined
): boolean => !!accessContext?.isOwner;
